import { Pagination } from "#components";
import { RowSkeleton, TableSkeleton } from "#skeleton";
import { NotFound } from "#UI";

export default function TableLayout({
  isLoading,
  isEmpty,
  tableHeader,
  children,
  currentPage,
  onDataCountChange,
  totalItems, // You need to pass totalItems as a prop
  rowLimit,
  handlePrevPage,
  handleNextPage,
  pagination,
}) {
  if (isLoading) {
    return (
      <TableSkeleton tableHeader={tableHeader}>
        <RowSkeleton tableData={tableHeader} />;
      </TableSkeleton>
    );
  }

  if (isEmpty) {
    return <NotFound />;
  }

  return (
    <>
      {children}
      {pagination ? null : (
        <Pagination
          currentPage={currentPage}
          onDataCountChange={onDataCountChange}
          totalItems={totalItems}
          rowLimit={rowLimit}
          handlePrevPage={handlePrevPage}
          handleNextPage={handleNextPage}
        />
      )}
    </>
  );
}
